import React from 'react';

const BADGE_STYLES = {
  ADMIN: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  COACH: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  PRO: 'bg-orange-100 text-primary dark:bg-orange-900/30 dark:text-orange-400',
};

const SubscriptionBadge = ({ badge }) => {
  if (!badge) return null;
  const style = BADGE_STYLES[badge] || '';

  return (
    <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide ml-1 ${style}`}>
      {badge}
    </span>
  );
};

export default SubscriptionBadge;
